import { Outlet, createFileRoute } from "@tanstack/react-router";

/** Layout for Plan mode. The index route (`w.$slug.plan.index.tsx`) is the
 * workspace's Plan home (canvases + artifacts); the org-wide "All work" rollup
 * lives at `w.$slug.plan.all.tsx`; project / work-package / objective / KR detail
 * screens render through the Outlet. The right-hand agent rail is rendered by
 * the app shell (`_app.tsx`) as a full-height sibling column so its header sits
 * level with the top bar — matching the chaidojo-design mockup. */
export const Route = createFileRoute("/_app/plan")({
  component: PlanLayout,
});

function PlanLayout() {
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <Outlet />
    </div>
  );
}
